import {Box, Stack, Typography} from "@mui/material";
import coin from "../../public/coin-svgrepo-com.svg";
import {useAppDispatch, useAppSelector} from "../app/store/hooks.ts";
import {setPaymentOpen} from "../app/store/slices/appSlice.ts";
import {isMobileChecker} from "../utils/IsMobileChecker.ts";
import {shallowEqual} from "react-redux";
import {liquidGlassStyle} from "../app/theme/liquidGlassStyle.ts";

export const BalanceHeader = () => {
    const dispatch = useAppDispatch();
    const balance = useAppSelector((state) => state.user.user?.balance ?? 0);
    const platform = useAppSelector((state) => state.app.platform) || 'unknown';
    const safeArea = useAppSelector((state) => state.app.safeArea, shallowEqual);
    const isMobile = isMobileChecker(platform)

    const handleClick = () => {
        dispatch(setPaymentOpen(true));
    };

    return (
        <Box height={'50px'} width={'100%'} display={'flex'} alignItems={'center'} justifyContent={isMobile ? 'center' : 'flex-end'}
             margin={'0 0 20px 0'} sx={{cursor: 'pointer'}} position={'fixed'} top={safeArea.top} padding={'0 20px'}  zIndex={1000}>
            <Stack
                direction={'row'}
                alignItems={'center'}
                spacing={'4px'}
                onClick={handleClick}
                justifyContent={'center'}
                sx={{
                    ...liquidGlassStyle,
                    minWidth: '100px',
                    padding: '8px 10px 2px 8px',
                    cursor: 'pointer',
                    borderRadius: '10px',
                    textTransform: 'none',
                }}
            >
                <Typography
                    sx={{opacity: 0.7, textAlign: 'center', fontWeight: '700', fontSize: '24px'}}>{balance}</Typography>
                <Box position={'relative'}>
                    <Box component={'img'} src={coin} alt={'coin'} width={'24px'} height={'24px'} sx={{opacity: 0.8}}/>
                    <Box
                        position={'absolute'}
                        top={'-4px'}
                        right={'-4px'}
                        width={'16px'}
                        height={'16px'}
                        borderRadius={'50%'}
                        bgcolor={'white'}
                        display={'flex'}
                        alignItems={'center'}
                        justifyContent={'center'}
                        sx={{fontSize: '14px', fontWeight: 'bold', color: 'black'}}
                    >
                        +
                    </Box>
                </Box>
            </Stack>
        </Box>
    )
};
